<coin-v2-dialog-frame [header]="'general.emulate' | translate">
  <div class="body-container">
    <div class="select-emulate-popup">
      @if (recentlyEmulated.length > 0) {
        <div class="recently-emulated-container">
          <p class="bold">{{ 'general.recently-emulated' | translate }}</p>
          <div class="recently-emulated-employees">
            @for (employee of displayedRecentlyEmulated; track $index) {
              <div class="recently-emulated-employee">
                <coin-siemens-energy-employee-preview
                  [employee]="employee"
                  (click)="proceed(employee)"></coin-siemens-energy-employee-preview>
                <coin-v2-button
                  class="remove-recently-emulated"
                  [type]="'outline'"
                  [icon]="'delete'"
                  (click)="removeRecentlyEmulated(employee, $event)"></coin-v2-button>
              </div>
            }
          </div>
          @if (hasMoreRecentlyEmulated) {
            <coin-v2-button
              class="recently-emulated-toggle"
              [type]="'secondary'"
              [icon]="showAllRecentlyEmulated ? 'expand_less' : 'expand_more'"
              [iconPos]="'right'"
              [text]="(showAllRecentlyEmulated ? 'general.show-less' : 'general.show-more') | translate"
              (click)="toggleShowAllRecentlyEmulated()"></coin-v2-button>
          }
        </div>
      }
      <div class="emulate-search">
        <coin-v2-text-input
          matFormFieldClass="shadow"
          [placeholder]="'general.gid' | translate"
          [label]="'general.user-gid' | translate"
          [(ngModel)]="user.gid"
          (keyup.enter)="search()"></coin-v2-text-input>
        <coin-v2-text-input
          placeholder="{{ 'general.lastname' | translate }}"
          label="{{ 'general.lastname' | translate }}"
          matFormFieldClass="shadow"
          [(ngModel)]="user.name.lastname"
          (keyup.enter)="search()"></coin-v2-text-input>
        <coin-v2-text-input
          placeholder="{{ 'general.firstname' | translate }}"
          label="{{ 'general.firstname' | translate }}"
          matFormFieldClass="shadow"
          [(ngModel)]="user.name.firstname"
          (keyup.enter)="search()"></coin-v2-text-input>
        <coin-v2-button
          [type]="'primary'"
          [icon]="'search'"
          [iconPos]="'right'"
          [text]="'general.search' | translate"
          (click)="search()"></coin-v2-button>
      </div>

      <div class="emulate-list">
        @if (loading) {
          <div
            animate.enter="expand"
            animate.leave="shrink"
            class="loading">
            <mat-progress-bar
              class="select-emu"
              mode="buffer"></mat-progress-bar>
          </div>
        }

        @if (emulateablePersons.content.length === 0 && !loading) {
          <p>{{ 'general.no-emulation-users-found' | translate }}</p>
        }

        @if (!loading) {
          <div class="user-list">
            @for (userItem of emulateablePersons.content; track userItem) {
              <coin-siemens-energy-employee-preview
                [employee]="userItem"
                (click)="proceed(userItem)"></coin-siemens-energy-employee-preview>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      [type]="'outline'"
      [icon]="'chevron_right'"
      [iconPos]="'right'"
      [text]="'general.btnCancel' | translate"
      (click)="cancel()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
